import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";

export const CopyToClipboardButton = (props: { data: string }) => {
  return (
    <IconButton
      onClick={async () => {
        await navigator.clipboard.writeText(props.data);
        showInfoToast("In die Zwischenablage kopiert");
      }}
    >
      <ContentCopyIcon />
    </IconButton>
  );
};
